<template>
    <div>
        <div v-if="showTemplateName">
            <pc-button
                link
                class="p-0"
                v-on:click="onTemplateNameClicked">
                <span class="fw-bold">{{ templateName }}</span>
            </pc-button>
        </div>
        <div v-if="showSummary">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    {{ errorSummary }}
                </div>
                <div>
                    <pc-button
                        link
                        class="p-0"
                        v-on:click="toggleDetails">
                        {{ detailsBtnLabel }}
                    </pc-button>
                </div>
            </div>
        </div>
        <pc-transition transition="slide">
            <div v-if="expanded">
                <div
                    v-if="missingUnsubscribeLink"
                    class="fw-bold">
                    {{ missingUnsubscribeLinkText }}
                </div>
                <div
                    v-if="hasUnexpectedUnsubscribeLink"
                    class="fw-bold">
                    {{ unexpectedUnsubscribeLinkText }}
                </div>
                <pc-expand-list
                    v-bind="listCommonBinder"
                    v-bind:header="invalidTagsHeader"
                    v-bind:items="malformedTags">
                    <template v-slot:content="tag">
                        <div v-bind:class="tagRowClasses">
                            <div class="flex-grow-1">
                                {{ tag.TagText }}
                            </div>
                        </div>
                    </template>
                </pc-expand-list>
                <pc-expand-list
                    v-bind="listCommonBinder"
                    v-bind:header="brokenRefTagsHeader"
                    v-bind:items="brokenReferenceTags">
                    <template v-slot:content="tag">
                        <div v-bind:class="tagRowClasses">
                            <div class="flex-grow-1">
                                {{ tag.TagText }}
                            </div>
                        </div>
                    </template>
                </pc-expand-list>
                <pc-expand-list
                    v-bind="listCommonBinder"
                    v-bind:header="archivedRefTagsHeader"
                    v-bind:items="archivedReferenceTags">
                    <template v-slot:content="tag">
                        <div v-bind:class="tagRowClasses">
                            <div class="flex-grow-1">
                                {{ tag.TagText }}
                            </div>
                        </div>
                    </template>
                </pc-expand-list>
                <pc-expand-list
                    v-bind="listCommonBinder"
                    v-bind:header="misplacedTagsHeader"
                    v-bind:items="misplacedTags">
                    <template v-slot:content="tag">
                        <div v-bind:class="tagRowClasses">
                            <div class="flex-grow-1">
                                {{ tag.TagText }}
                            </div>
                        </div>
                    </template>
                </pc-expand-list>
            </div>
        </pc-transition>
    </div>
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/tagErrors.i18n";

    export default {
        props: {
            createTagsResultModel: { type: Object, required: true },
            showTemplateName: { type: Boolean, required: false, default: false },
            useCollapsedView: { type: Boolean, required: false, default: false }
        },
        emits: ["template-name-click"],
        data() {
            return {
                tagRowClasses: "d-flex align-items-center justify-content-between ms-3",
                expanded: !this.useCollapsedView
            };
        },
        computed: {
            templateName() {
                return this.createTagsResultModel.TemplateName;
            },
            templateId() {
                return this.createTagsResultModel.TemplateId;
            },
            showSummary() {
                return this.useCollapsedView;
            },
            errorCount() {
                return this.malformedTags.length + this.brokenReferenceTags.length + this.archivedReferenceTags.length;
            },
            detailsBtnLabel() {
                return this.expanded ? this.hideDetailsBtnLabel : this.showDetailsBtnLabel;
            },
            malformedTags() {
                return this.createTagsResultModel.MalformedTags;
            },
            brokenReferenceTags() {
                return this.createTagsResultModel.BrokenReferenceTags;
            },
            archivedReferenceTags() {
                return this.createTagsResultModel.ArchivedReferenceTags;
            },
            misplacedTags() {
                return this.createTagsResultModel.MisplacedSubjectTags;
            },
            unsubscribeLink() {
                return this.createTagsResultModel.UnsubscribeLink;
            },
            missingUnsubscribeLink() {
                return this.createTagsResultModel.IsAnnouncement && this.createTagsResultModel.UnsubscribeLink == null;
            },
            hasUnexpectedUnsubscribeLink() {
                return !this.createTagsResultModel.IsAnnouncement && this.createTagsResultModel.UnsubscribeLink != null;
            },
            listCommonBinder() {
                return {
                    hideIfEmpty: true,
                    class: "mb-2",
                    keyPropGetter: "TagText",
                    /**
                     * If using collapsed view, we show a summary with a "details" link.
                     * In that case, we will automatically expand all the sub-lists when the
                     * single details link is clicked
                     */
                    alwaysExpanded: this.useCollapsedView
                };
            },
            ...mapI18n(
                {
                    ...KEYS,
                    errorSummary() {
                        return {
                            key: KEYS.errorSummary,
                            values: { tagCount: this.errorCount },
                            count: this.errorCount
                        };
                    },
                    missingUnsubscribeLinkText() {
                        return {
                            key: KEYS.missingUnsubscribeLinkErrorMessage,
                            values: { unsubscribeTag: "{UnsubscribeLink}" }
                        };
                    },
                    unexpectedUnsubscribeLinkText() {
                        return {
                            key: KEYS.unexpectedUnsubscribeLinkErrorMessage,
                            values: { unsubscribeTag: "{UnsubscribeLink}" }
                        };
                    }
                },
                NAMESPACE
            )
        },
        methods: {
            toggleDetails() {
                this.expanded = !this.expanded;
            },
            onTemplateNameClicked() {
                this.$emit("template-name-click", { name: this.templateName, id: this.templateId });
            }
        }
    };
</script>
